<template>
<div class="drop-down-menu">
  <div class="select-type">
    <div
      class="check_box"
      v-for="(item, index) in checkMenu"
      :key="index"
      :id="item.title"
      @click="checkTree(item)">
      <img v-if="item.childList" :src="item.img_url" />
      <span v-if="item.childList">{{ item.title }}</span>
    </div>
  </div>
  <div class="select-menu">
    <el-tree :data="menuTree.childList" class="treeMenu" :props="defaultProps"  node-key="$treeNodeId" default-expand-all @node-click="getCurrentKey" highlight-current>
      <div class="custom-tree-node" slot-scope="{ node, data }">
          <div
            v-if="!data.group && !node.isLeaf"
            class="expend_icon"
            @click.stop="() => changeExpend(node)" >
            <img
              :id="node.id"
              :src="node.expanded ? '../static/img/expendOff.png' : '../static/img/expendOn.png'"/>
          </div>
          <span v-show='data.group' class="tree-title-parent">{{data.key}}</span>
          <span v-show="!data.group" :class="!data.group && !node.isLeaf ? 'tree-title-child' : 'tree-title-child_leaf'" ref="label">{{data.key}}({{data.doc_count}})</span>
      </div> 
    </el-tree>
  </div>
</div>
</template>

<script>
name: "dropDownMenu";
export default {
  props:{
    statisticalList:{
      type:Object,
    }
  },
  data() {
    return {
      defaultProps: {
        children: "childList",
        label: "key"
      },
      content_tree: [
        {
          id: 1,
          title: "发稿地域",
          group: "address",
          img_url: "../static/img/publish_zone1.png",
          childList: [
          ]
        },
        {
          id: 2,
          title: "媒体单位",
          group: "media",
          img_url: "../static/img/media_group.png",
          childList: [
          ]
        },
        { 
          id: 3,
          title: "发布时间",
          group: "date",
          img_url: "../static/img/publish_time.png",
          childList: [
          ]
        },
        {
          id: 4,
          title: "来源类型",
          group: "source_type",
          img_url: "../static/img/souce_type.png",
          childList: [
          ]
        },
        {
          id: 5,
          title: "内容类型",
          group: "content_type",
          img_url: "../static/img/article_type.png",
          childList: [
          ]
        }
      ],
      media_tree:[
        {
          id: 1,
          title: "媒体类型",
          group: "type",
          img_url: "../static/img/media_group1.png",
          childList: [
          ]
        },
        {
          id: 2,
          title: "媒体所在地",
          group: "address",
          img_url: "../static/img/publish_zone.png",
          childList: [
          ]
        }
      ],
      editor_tree:[
        {
          id: 1,
          title: "所在媒体",
          group: "media",
          img_url: "../static/img/media_group1.png",
          childList: [
          ]
        },
        {
          id: 2,
          title: "所在地域",
          group: "address",
          img_url: "../static/img/publish_zone.png",
          childList: [
          ]
        }
      ],
      more_tree: [
        {
          id: 1,
          title: "发布时间",
          group: "date",
          img_url: "../static/img/publish_time1.png",
          childList: [
          ]
        },
        {
          id: 2,
          title: "来源类型",
          group: "source_type",
          img_url: "../static/img/souce_type.png",
          childList: [
          ]
        },
        {
          id: 3,
          title: "内容类型",
          group: "content_type",
          img_url: "../static/img/article_type.png",
          childList: [
          ]
        }
      ],
      Nodepath:'',
      expend:'../static/img/expendOff.png',
      menuTree:{}
    };
  },
  computed:{
    checkMenu () {
      let path = this.$route.path
      if (path === '/pressMedia') {
        return this.media_tree
      } else if (path === '/editorReporter') {
        return this.editor_tree
      } else if (path === '/readmore') {
        return this.more_tree
      } else {
        return this.content_tree
      }
    }
  },
  created(){
  },
  mounted(){
    this.menuTree = this.checkMenu[0]
    this.checkTree(this.menuTree)
  },
  methods: {
    checkTree (item) {
      for (let value of this.checkMenu) {
        value.img_url = value.img_url.replace('1', '')
        document.getElementById(value.title).style = 'color: rgba(92,92,92,0.5)'
      }
      if (item.img_url.indexOf('1') < 0) {
        item.img_url = item.img_url.replace(/.png/, '1.png')
        document.getElementById(item.title).style = 'color: rgba(92,92,92,1)'
        this.menuTree = item
      }
    },
    changeExpend(node){
      //console.log(node)
      // console.log(node.expanded)
      let id = node.id
      node.expanded = !node.expanded
    },
    getCurrentKey(data,node,event) {
      // /console.log(data)
      //console.log(node)
      //console.log(event)
      var selectNode = node
      //console.log(selectNode)
      var selectedLabelArray = []
      var NodePath = []
      if(!data.group){
        // //console.log(node)
        this.recursionParent(selectNode,selectedLabelArray)
        this.$emit("getNode", selectNode,this.Nodepath,this.menuTree.group );
      }
    },
    recursionParent(node,path){
      if (!node.key) {
        this.Nodepath = path.reverse().join('-')
        //console.log(this.Nodepath)
        return
      }
      path.push(node.data.key)
      this.recursionParent(node.parent,path)
    },
    sortChinese (arr, dataLeven) { // 参数：arr 排序的数组; dataLeven 数组内的需要比较的元素属性
        /* 获取数组元素内需要比较的值 */
        function getValue (option) { // 参数： option 数组元素
          if (!dataLeven) return option
          var data = option
          dataLeven.split('.').filter(function (item) {
            data = data[item]
          })
          return data + ''
        }
        arr.sort(function (item1, item2) {
            return getValue(item1).localeCompare(getValue(item2), 'zh-CN');
        })
        for(var i = 0;i<arr.length;i++){
           if(arr[i].childList){
              this.sortChinese(arr[i].childList,'key')
            }
        }
    },
    setContentTree(){
      if(this.$route.path === '/contentsearch' || this.$route.path === '/contentName' || this.$route.path === '/contentDepartment' || this.$route.path === '/contentSites'){
        for(var i = 0;i<this.content_tree.length;i++){
          switch(this.content_tree[i].title){
            case '发稿地域': if(this.statisticalList.address){
              this.sortChinese(this.statisticalList.address,'key')
              this.content_tree[i].childList = this.statisticalList.address;
            }break;
            case '媒体单位': if(this.statisticalList.media){
              this.sortChinese(this.statisticalList.media,'key')
              this.content_tree[i].childList = this.statisticalList.media;
            }break;
            case '发布时间': if(this.statisticalList.date){
              for(var j = 0; j < this.statisticalList.date.length; j++){
                if(this.statisticalList.date[j].key != null){
                  if(this.statisticalList.date[j].key.indexOf('h') > -1){
                    this.statisticalList.date[j].key = this.statisticalList.date[j].key.replace(/h/g,"小时内")
                  }
                  else if(this.statisticalList.date[j].key.indexOf('d') > -1){
                    this.statisticalList.date[j].key = this.statisticalList.date[j].key.replace(/d/,"天内")
                  }
                  else if(this.statisticalList.date[j].key.indexOf('y') > -1){
                    this.statisticalList.date[j].key = this.statisticalList.date[j].key.replace(/y/,"年内")
                  }
                }
              }
              this.content_tree[i].childList = this.statisticalList.date;
            }break;
            case '来源类型': if(this.statisticalList.source_type){
              this.sortChinese(this.statisticalList.source_type,'key')
              this.content_tree[i].childList = this.statisticalList.source_type;
            }break;
            case '内容类型': if(this.statisticalList.content_type){
              this.sortChinese(this.statisticalList.content_type,'key')
              this.content_tree[i].childList = this.statisticalList.content_type;
            }break;
          }
        }
        // for(var i = 0;i<this.content_tree.length;i++){
        //   if(this.content_tree[i].childList.length === 0 || this.content_tree[i].childList[0].key === null){
        //     this.content_tree.splice(i,1)
        //     i = -1
        //   }
        // }
      }
      else if(this.$route.path === '/pressMedia'){
        for(var i = 0;i<this.media_tree.length;i++){
          switch(this.media_tree[i].title){
            case '媒体类型': if(this.statisticalList.type){
              this.sortChinese(this.statisticalList.type,'key')
              this.media_tree[i].childList = this.statisticalList.type;
            }break;
            case '媒体所在地': if(this.statisticalList.address){
              this.sortChinese(this.statisticalList.address,'key')
              this.media_tree[i].childList = this.statisticalList.address;
            }break;
          }
        }
      }
      else if(this.$route.path === '/editorReporter'){
        // this.menuTree = this.tree3.slice()
        for(var i = 0;i<this.editor_tree.length;i++){
          switch(this.editor_tree[i].title){
            case '所在媒体': if(this.statisticalList.media){
              this.sortChinese(this.statisticalList.media,'key')
              this.editor_tree[i].childList = this.statisticalList.media;
            }break;
            case '所在地域': if(this.statisticalList.address){
              this.sortChinese(this.statisticalList.address,'key')
              this.editor_tree[i].childList = this.statisticalList.address;
            }break;
          }
        }
      }
      else if(this.$route.path === '/readmore'){
        for(var i = 0;i<this.more_tree.length;i++){
          switch(this.more_tree[i].title){
            case '发布时间': 
            if(this.statisticalList.date){
              for(var j = 0; j < this.statisticalList.date.length; j++){
                //debugger
                if(this.statisticalList.date[j].key != null){
                  if(this.statisticalList.date[j].key.indexOf('h') > -1){
                    this.statisticalList.date[j].key = this.statisticalList.date[j].key.replace(/h/g,"小时内")
                  }
                  else if(this.statisticalList.date[j].key.indexOf('d') > -1){
                    this.statisticalList.date[j].key = this.statisticalList.date[j].key.replace(/d/,"天内")
                  }
                  else if(this.statisticalList.date[j].key.indexOf('y') > -1){
                    this.statisticalList.date[j].key = this.statisticalList.date[j].key.replace(/y/,"年内")
                  }
                }
              }
              this.more_tree[i].childList = this.statisticalList.date;
            }break;
            case '来源类型': if(this.statisticalList.source_type){
              this.sortChinese(this.statisticalList.source_type,'key')
              this.more_tree[i].childList = this.statisticalList.source_type;
            }break;
            case '内容类型': if(this.statisticalList.content_type){
              this.sortChinese(this.statisticalList.content_type,'key')
              this.more_tree[i].childList = this.statisticalList.content_type;
            }break;
          }
        }
      }
    }
  },
  watch:{
    statisticalList(newVal){
      this.statisticalList = newVal
      this.setContentTree()
      //console.log(this.tree[0])
      //console.log(this.statisticalList)
    }
  }
};
</script>

<style >
.drop-down-menu {
  width: 100%;
  height: 800px;
  position: relative;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}

.drop-down-menu .select-type {
  width: 50px;
  height: calc(100% - 30px);
  padding: 15px;
  position: absolute;
  box-shadow:0px 1px 4px 0px rgba(0, 0, 0, 0.15);
  border-radius:6px 0px 0px 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.select-type .check_box {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 38px;
  cursor: pointer;
  font-size:14px;
  font-family:思源黑体;
  font-weight:400;
  color:rgba(92,92,92,0.5);
}

.check_box img {
  margin-bottom: 8px;
  width: 41px;
  height: 41px;
}

.drop-down-menu .select-menu {
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 0 5px;
  margin-left: 80px;
  box-sizing: border-box;
}
.treeMenu .custom-tree-node {
  display: flex;
  align-items: center;
}
.treeMenu .tree-title-parent{
  display: inline-block;
  margin-left:10px;
  font-size:18px;
  font-family:思源黑体;
  font-weight:400;
  color:rgba(51,51,51,1);
  word-break: break-all;
  white-space: normal;
}
.treeMenu .tree-title-child{
  display: inline-block;
  font-size: 16px;
  font-family: 思源黑体;
  font-weight: 400;
  color: rgba(102,102,102,1);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
}
.treeMenu .tree-title-child_leaf{
  display: inline-block;
  margin-left: 20px;
  font-size: 14px;
  font-family: 思源黑体;
  font-weight: 400;
  color: rgba(102,102,102,1);
  word-break: break-all;
  white-space: normal;
}
.treeMenu .tree-icon {
  display: inline-block;
}
.treeMenu .child-class {
  margin-left: 40px;
}
.treeMenu .child-class img {
  display: none;
}
.treeMenu .group-class img {
  padding-right: 30px;
  margin-left: 15px;
  width: 15px;
  height: 15px;
}
.treeMenu .el-tree-node__content > .el-tree-node__expand-icon {
    padding: 0px;
}
.treeMenu .el-tree-node:focus>.el-tree-node__content{
    color: #359AFF;
}
.treeMenu .el-tree-node__expand-icon {
    cursor: pointer;
    color: #646464;
    font-size: 17px;
    -webkit-transform: rotate(0);
    transform: rotate(0);
    -webkit-transition: -webkit-transform .3s ease-in-out;
    transition: -webkit-transform .3s ease-in-out;
    transition: transform .3s ease-in-out;
    transition: transform .3s ease-in-out, -webkit-transform .3s ease-in-out;
    transition: transform .3s ease-in-out,-webkit-transform .3s ease-in-out;
}
.treeMenu .el-tree-node__content > .el-tree-node__expand-icon {
    padding: 6px;
}
.treeMenu .el-icon-caret-right:before {
    content: "\E60E";
    display: none;
}
.treeMenu .expend_icon{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  width: 20px;
  height: 20px;
}
.expend_icon img {
  width: 12px;
  height: 12px;
}
.treeMenu .el-tree-node__content {
    display: -webkit-box;
    display: -ms-flexbox;
    /* margin-top: 16px; */
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    cursor: pointer;
    font-size: 10px;
    padding: 15px 0;
    line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/dropDownMenu.vue